import { useQuery } from '@tanstack/react-query';

import { useProfile } from 'context/profile';
import { dischargeCalendarQueryKeys, getDischargeCalendarCounts } from 'services/api/dischargeCalendar';
import { useDischargeCalendarFilters, useDischargeCalendarSearch } from 'stores/dischargeCalendarStore';

interface UseDischargeCalendarCountsOptions {
  startDate: Date;
  endDate: Date;
}

export default function useDischargeCalendarCounts({ startDate, endDate }: UseDischargeCalendarCountsOptions) {
  const { profile } = useProfile();
  const filters = useDischargeCalendarFilters();
  const search = useDischargeCalendarSearch();

  return useQuery({
    queryKey: dischargeCalendarQueryKeys.counts({
      clientId: profile.actingClientId,
      startDate: startDate.toISOString(),
      endDate: endDate.toISOString(),
      filters,
      search,
    }),
    queryFn: ({ signal }) => getDischargeCalendarCounts({ startDate, endDate, filters, search }, signal),
    staleTime: 30000,
  });
}
